import { FuseConfig, FuseLoginConfig } from '@mobileia/layout-fuse';

export const fuseConfig: FuseConfig = {
    // Color themes can be defined in src/app/app.theme.scss
    colorTheme      : 'theme-default',
    customScrollbars: true,
    layout          : {
        style    : 'vertical-layout-1',
        width    : 'fullwidth',
        navbar   : {
            primaryBackground  : 'green-800',
            secondaryBackground: 'blue-grey-900',
            folded             : false,
            hidden             : false,
            position           : 'left',
            variant            : 'vertical-style-1',
            showUser           : false,
            title              : 'Plaza Hogar',
            iconUrl            : 'assets/logo/plaza-hogar.svg'
        },
        toolbar  : {
            customBackgroundColor: false,
            background           : 'fuse-white-500',
            hidden               : false,
            position             : 'below-static',
            userMenu : [
                {
                    id       : 'logout',
                    title    : 'Logout',
                    type     : 'item',
                    icon     : 'exit_to_app'
                },
            ],
            showAvatar: false,
            userName: 'Procesando...',
            userAvatarUrl: '',
            showNotifications: false,
            notifications: [],
            countNotifications: 0
        },
        footer   : {
            customBackgroundColor: true,
            background           : 'fuse-navy-900',
            hidden               : true,
            position             : 'below-static'
        },
        sidepanel: {
            hidden  : false,
            position: 'right'
        }
    }
};

export const fuseLoginConfig: FuseLoginConfig = {
    imageBackground: 'assets/background/dark-material-bg.jpg',
    imageLogo: 'assets/logo/plaza-hogar.svg',
    title: '',
    btnColorClass: 'default',
    titleBtn: 'LOGIN',
    isRecovery: false,
    isRegister: false,
    isRemember: false,
    successRoute: '/product',
    verifyRole: false,
    withRole: 0,
    isInternal: true
};